import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=b8ff90a6&scoped=true"
import script from "./MyReports.vue?vue&type=script&lang=js"
export * from "./MyReports.vue?vue&type=script&lang=js"
import style0 from "./MyReports.vue?vue&type=style&index=0&id=b8ff90a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff90a6",
  null
  
)

export default component.exports